import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import { AuthProvider } from './contexts/AuthContext';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import { SearchStateProvider } from './contexts/SearchStateContext';
import { GOOGLE_PLACES_API_KEY, MAP_LIBRARIES } from './components/Map/mapConfig';
import Home from './pages/Home';
import Search from './pages/Search';
import SignIn from './pages/SignIn';
import Profile from './pages/Profile';
import Account from './pages/Account';
import Config from './pages/Config';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <AuthProvider>
      <UserPreferencesProvider>
        <SearchStateProvider>
          {/* APIProvider must live above the router so it never unmounts between
              page navigations. Re-mounting it causes "google.maps.Map is not a
              constructor" because the SDK script is already in the window. */}
          <APIProvider apiKey={GOOGLE_PLACES_API_KEY} libraries={MAP_LIBRARIES}>
            {/* Map-heavy /search starves concurrent transitions: history updates but <Routes> lags. */}
            <BrowserRouter unstable_useTransitions={false}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<Search />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/account" element={<Account />} />
                <Route path="/config" element={<Config />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
              </Routes>
            </BrowserRouter>
          </APIProvider>
        </SearchStateProvider>
      </UserPreferencesProvider>
    </AuthProvider>
  );
}

export default App;
